import { render, staticRenderFns } from "./msgbox.vue?vue&type=template&id=50ce0a0d&lang=pug&"
import script from "./msgbox.vue?vue&type=script&lang=js&"
export * from "./msgbox.vue?vue&type=script&lang=js&"
import style0 from "./msgbox.vue?vue&type=style&index=0&id=50ce0a0d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports